export const resendCodeForgotPasswordMutation = `
  mutation ResendCodeForgotPasswordMutation($email: String!) {
    ResendCodeForgotPassword (email: $email) {
      success
    }
  }  
`;
